import React, { useEffect, useState } from "react";
import Loader from "components/Loader";
import TeamService from "services/TeamService";
import TimeFilter from "components/TimeFilter";
import PeerRecognitionStatsDetailsCard from "./PeerRecognitionStatsDetailsCard";
import Scrollbar from "react-scrollbars-custom";

const styles = {
  detailsContainer: {
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
  },
  loadMoreButton: {
    textAlign: "center",
  },
  timeFilter: {
    height: "35px",
  },
  detailCardContainer: {
    display: "flex",
    flex: 1,
    overflow: "auto",
  },
  loaderStyle: {
    display: "flex",
    justifyContent: "center",
  },
};

export default ({ recognitionStats, opened, team_id, time, setTime }) => {
  const classes = styles;
  const [loading, setLoading] = useState(true);
  const [recognitions, setRecognitions] = useState([]);
  const loaderStyle = {
    display: "flex",
    justifyContent: "center",
  };

  useEffect(() => {
    if (!opened) {
      setRecognitions([]);
      setLoading(true);
      return;
    }

    (async () => {
      setLoading(true);

      try {
        const response = await TeamService.getRecognitionStatsDetails(
          team_id,
          time
        );

        setRecognitions([...response.data.data.users]);

        setLoading(false);
      } catch (e) {
        console.log(e);
      }
    })();

    // eslint-disable-next-line
  }, [opened, team_id, time]);

  if (!opened) {
    return <Loader loaderStyle={loaderStyle} />;
  }

  const updateTime = (updatedTime) => {
    setTime(updatedTime);
  };

  const LoadingContainer = (
    <>
      {loading && (
        <h4 style={{ display: "flex", justifyContent: "center" }}>
          <Loader loaderStyle={classes.loaderStyle} />
        </h4>
      )}
    </>
  );

  return (
    <div style={classes.detailsContainer}>
      <div style={classes.timeFilter}>
        <TimeFilter time={time} setTime={updateTime} color={"black"} />
      </div>
      <div style={classes.detailCardContainer}>
        <Scrollbar>
          <div className="recognitionStateMain">
            {recognitions.map((recognition) => (
              <PeerRecognitionStatsDetailsCard
                recognitionStats={recognitionStats}
                key={recognition.id}
                recognition={recognition}
              />
            ))}
          </div>
          {LoadingContainer}
        </Scrollbar>
      </div>
    </div>
  );
};
